import type { IMembershipRepository } from '../repositories/IMembershipRepository.js';

interface Deps { membershipRepository: IMembershipRepository; }
export interface UpdateMemberRoleInput { membershipId: string; roleId: string; }
export function createUpdateMemberRoleUseCase({ membershipRepository }: Deps) {
  return async function updateMemberRole(input: UpdateMemberRoleInput): Promise<void> {
    return membershipRepository.updateMemberRole(input.membershipId, input.roleId);
  };
}
